import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import AccessDenied from './AccessDenied';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireWhitelist?: boolean;
}

export default function ProtectedRoute({
  children,
  requireWhitelist = true,
}: ProtectedRouteProps) {
  const { isAuthenticated, isWhitelisted, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-gray-400">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to home page, preserving the attempted URL
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check whitelist for protected routes
  if (requireWhitelist && !isWhitelisted) {
    return <AccessDenied />;
  }

  return <>{children}</>;
}
